import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useRoutes } from '@/common/hooks';
import { FASTSHIFT_PATH_KEYS, FASTSHIFT_PATHS } from '@/common/routes/constants';
import { useFastshiftSelector } from '@/state';

import { LegalConsentPage } from '../../legal-consent';

import { CriticalErrorDisplay } from './critical-error-display/critical-error-display';
import { useShouldShowConsentLandingPage } from './hooks';

export const FastshiftPage = () => {
	const { paths, getPathByDomainId } = useRoutes();

	const { data: user } = useFastshiftSelector((state) => state.userAccess);
	const navigate = useNavigate();
	const isPartnerOrInternal = user?.userType === 'PARTNER' || user?.userType === 'INTERNAL';

	const { data: userHasConsented } = useFastshiftSelector((state) => state.portalUserConsent);

	const shouldShowConsentLandingPage = useShouldShowConsentLandingPage();

	useEffect(() => {
		if (user) {
			if (user.userType === 'CUSTOMER') {
				// if customer has not consented yet, remain on Home page
				if (!userHasConsented) {
					return;
				}
				// customer has consented, so redirect to For You Page
				const url = getPathByDomainId(
					FASTSHIFT_PATHS[FASTSHIFT_PATH_KEYS.OVERVIEW],
					user.userDomain?.domainId ?? '',
				);
				if (url) {
					navigate(url);
				}
			} else if (isPartnerOrInternal) {
				const url = paths.selection;
				if (url) {
					navigate(url);
				}
			}
		}
	}, [user, isPartnerOrInternal, navigate, getPathByDomainId, paths.selection, userHasConsented]);

	if (shouldShowConsentLandingPage) {
		return <LegalConsentPage />;
	}

	return <CriticalErrorDisplay />;
};
